/* @flow */

import { makePriorityHeader } from "../utils/RequestUtil";
import { Request } from "../services/Requests";
const RequestBuilder = new Request.Builder("customerassist", "alexcustomerdata");
import * as PriorityUtil from "../utils/PriorityUtil";

import { AddressValidation } from "../datatypes/customer/AddressValidation";
import { AddressType } from "../datatypes/Address";

export function getCustomer(customerid: string): Promise<any> {
    const template = "/customer/{customerId}";
    return RequestBuilder.path(template, { customerId: customerid })
        .header(makePriorityHeader(PriorityUtil.HIGH))
        .get();
}

export function postWebShopAddress(customerId: string, query: AddressType): Promise<any> {
    const template = "/customer/{customerId}/web-shop-addresses/add";
    return RequestBuilder.path(template, { customerId: customerId }).body(query).post();
}

export function deleteWebShopAddress(customerId: string, addressId: string): Promise<any> {
    const template = "/customer/{customerId}/web-shop-addresses/{addressId}";
    return RequestBuilder.path(template, { customerId: customerId, addressId: addressId }).retry().delete();
}

export function validateWebShopAddress(address: AddressType): Promise<AddressValidation> {
    const template = "/customer/web-shop-addresses/validate";
    return RequestBuilder.path(template, {}).body(address).post();
}
